<template>
  <div>
    <el-table id="codingLargeStatConsultants" :data="dashboardData.length ? dashboardData[0].largeStats[0].data : []" empty-text="No Data Available" :fit="true"
      :height="isModal ? null : resolvedTableHeight" show-summary :summary-method="getSummary">
      <el-table-column prop="consultant" label="Consultant" sortable>
        <template slot-scope="scope">
          <avatar :fullname="scope.row.consultantName" :image="scope.row.photo" :size="30"></avatar>
        </template>
      </el-table-column>
      <el-table-column type="expand" id="consultantHeaderExpand">
        <template slot-scope="props">
          <el-table :data="consultantGetDrillDownForRow(props.row)" empty-text="No Patient Types Available" :fit="true">
            <el-table-column prop="patientType" label="Patient Type" sortable>
            </el-table-column>
            <el-table-column prop="patientTypeTotal" label="Total Records" sortable>
              <template slot-scope="scope">
                {{scope.row.patientTypeTotal > 0 ? scope.row.patientTypeTotal : '--' }}
              </template>
            </el-table-column>
            <el-table-column prop="consultantTotalCharges" label="Total Charges" sortable :formatter="moneyFormatter">
              <template slot-scope="scope">
                {{scope.row.patientTypeTotal > 0 ? `$${formatMoney(scope.row.consultantTotalCharges)}` : '--' }}
              </template>
            </el-table-column>
            <el-table-column prop="consultantTotalHoursWorked" label="Hours Worked" sortable>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Records" sortable>
      </el-table-column>
      <el-table-column prop="totalCharges" label="Total Charges" sortable :formatter="moneyFormatter">
      </el-table-column>
      <el-table-column prop="totalHoursWorked" label="Hours Worked" sortable>
      </el-table-column>
    </el-table>
    <div style="font-size: 15px; position: absolute; bottom: 5px;">
      {{dashboardData.length ?dashboardData[0].largeStats[0].footer : ''}}
    </div>
  </div>
</template>

<script>
  import money from '@/mixins/money'
  import avatar from '@/components/avatar'

  export default {
    props: {
      dashboardData: {
        type: Array,
        default: () => []
      },
      tableHeight: {
        type: [String, Number],
        default: 450
      }
    },
    mixins: [money],
    components: {
      avatar
    },
    data: function () {
      return {
      }
    },
    name: 'PatientSafetyIndicatorsTable',
    methods: {
      moneyFormatter(row, column) {
        return `$${this.formatMoney(row.totalCharges || row.consultantTotalCharges)}`
      },
      consultantGetDrillDownForRow(row) {
        return row.patientTypes.length ? row.patientTypes.filter(f => f.clientHide === false) : []
      },
      totalSummary(column, data) {
        let response = data.reduce((total, curr) => {
          const value = Number(curr[column])
          if (!isNaN(value)) {
            return total + value
          } else {
            return total
          }
        }, 0)

        return response
      },
      getSummary(param) {
        const totalRecords = this.totalSummary('totalRecords', param.data)
        const totalCharges = this.totalSummary('totalCharges', param.data)
        const hoursWorked = this.totalSummary('totalHoursWorked', param.data)

        return [null, null, totalRecords, `$${this.formatMoney(totalCharges)}`, hoursWorked.toFixed(2)]
      }
    },
    created: function () {
    },
    computed: {
      isModal() {
        return this.$parent.modal
      },
      resolvedTableHeight() {
        return String(this.tableHeight)
      }
    }
  }
</script>
